export default { options: { label: 'Brand Market Assets Groups' } }
